import { Core } from '@springtree/eva-services-core';
import buildServiceState from '../../builders/build-service-state.js';
import currentUserState from '../current-user/current-user-state.js';
import { getReactRecoilSettings } from '../../settings.js';
const customerOrderListState = buildServiceState({
    key: 'customerOrderList',
    requireCustomer: true,
    service: Core.ListOrdersForCustomer,
    beforeRequest: ({ req, get }) => {
        // We can safely cast to current user response because
        // we `requireCustomer` in the parameters to the builder
        //
        const currentUser = get(currentUserState.response);
        const settings = getReactRecoilSettings();
        const newRequest = {
            PageConfig: {
                Start: 0,
                Limit: settings.defaultPageSize,
            },
            ...req,
            ID: currentUser.User.ID,
        };
        return newRequest;
    },
});
export default customerOrderListState;
//# sourceMappingURL=customer-order-list-state.js.map